// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__zFHjb","label":"Completed_label__1697X"};